<template>
    <h2 class="chat-header" v-if="channel || users">
        <a href="javascript:void(0)" class="chat-close"></a>
        <img :src="env.public_base + '/assets/images/multiple-people.svg'" alt="">
        <span class="chat-header__name">
            <span v-if="allPrefix">{{$t('all')}} </span>
            {{ $t('members') }}
        </span>

        <span class="badge badge-success is-hidden">0</span>
        <app-search-members></app-search-members>
    </h2>
</template>

<script>
    import {mapGetters} from 'vuex';
    import env from '../../env';
    import searchMembers from '../../chats/components/SearchFormMembers';

    export default {
        data: function () {
            return {
                env,
            }
        },
        components: {
            appSearchMembers: searchMembers
        },
        computed: {
            ...mapGetters([
                'channel',
                'users',
                'allPrefix'
            ])
        },

    }
</script>
